export default "__VITE_ASSET__8G1_V$Y5__"